/**
 * @generated SignedSource<<6a3b34683a964242f1f0023b89bf4000>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoEditMainExpireSelector_Todo$data = {
  readonly expireAtDate: {
    readonly isoString: string;
  } | null;
  readonly id: string;
  readonly updatedAtDate: {
    readonly isoString: string;
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  } | null;
  readonly updatedBy: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly " $fragmentType": "WorkspaceTodoEditMainExpireSelector_Todo";
};
export type WorkspaceTodoEditMainExpireSelector_Todo$key = {
  readonly " $data"?: WorkspaceTodoEditMainExpireSelector_Todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainExpireSelector_Todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoEditMainExpireSelector_Todo",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "expireAtDate",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "updatedAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormattedDate"
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "0f4d8c38666afb5640e415e75a9a8b53";

export default node;
